let ctx = null;

function ac() {
  if (ctx) return ctx;
  const AC = globalThis.AudioContext || globalThis.webkitAudioContext;
  if (!AC) return null;
  ctx = new AC();
  return ctx;
}

function blip(freq, dur, type = "square", vol = 0.045) {
  const audio = ac();
  if (!audio) return;
  if (audio.state === "suspended") audio.resume?.();
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.value = vol;
  osc.connect(gain);
  gain.connect(audio.destination);
  const now = audio.currentTime;
  gain.gain.exponentialRampToValueAtTime(0.0001, now + dur);
  osc.start(now);
  osc.stop(now + dur);
}

export function resume() { ac()?.resume?.(); }
export function move() { blip(196, 0.055, "square", 0.04); }
export function hit() { blip(82, 0.14, "sawtooth", 0.055); }
export function ui() { blip(392, 0.035, "triangle", 0.03); }
export function win() { blip(523, 0.18, "triangle", 0.04); }
export function boom() { blip(48, 0.2, "sawtooth", 0.06); }
/** Short per-weapon bark so a volley reads as different guns, not one generic hit. */
export function weapon(type) {
  if (type === "artillery" || type === "battleship") { blip(64, 0.2, "sawtooth", 0.065); blip(38, 0.26, "triangle", 0.04); }
  else if (type === "jet" || type === "helicopter") blip(540, 0.1, "sawtooth", 0.04);
  else if (type === "aa") { blip(880, 0.05, "square", 0.03); blip(210, 0.09, "sawtooth", 0.03); }
  else if (type === "gunboat" || type === "destroyer" || type === "coastal") blip(150, 0.1, "square", 0.05);
  else blip(110, 0.09, "square", 0.045);
}
